export var ESystemEventType;
(function (ESystemEventType) {
    ESystemEventType["POST"] = "system.post";
})(ESystemEventType || (ESystemEventType = {}));
